import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconLockRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.013 8.001a5 5 0 0 1 10 0v.998h.5c1.345 0 2.5 1.06 2.5 2.444v7.111c0 1.385-1.155 2.445-2.5 2.445h-11c-1.345 0-2.5-1.06-2.5-2.445v-7.11c0-1.386 1.155-2.445 2.5-2.445h.5V8Zm8 0v.998h-6V8a3 3 0 1 1 6 0Zm-8.5 2.998c-.312 0-.5.234-.5.444v7.111c0 .21.188.445.5.445h11c.312 0 .5-.234.5-.445v-7.11c0-.211-.188-.445-.5-.445h-11Zm6.782 2.88c0 .426-.213.803-.54 1.033a.499.499 0 0 1 .041.157l.119 1.32a.5.5 0 0 1-.498.546h-.802a.5.5 0 0 1-.497-.551l.135-1.32a.496.496 0 0 1 .035-.14 1.262 1.262 0 0 1-.558-1.045c0-.7.574-1.267 1.283-1.267.708 0 1.282.567 1.282 1.267Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconLockRoundLine);
export default Memo;
